import React, {useEffect, useState} from 'react'
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import { TypeOptions } from '../../../../data/TypeOptions';
import { FreightInformationProps } from '../../../../pages/get-quote/models';
import { TextField, InputAdornment, IconButton, MenuItem, Autocomplete, CircularProgress, Tooltip } from '@mui/material';
import { useStyles, DivContainerStyled } from './FreightInformationStyles';
import UNLookupModal from '../../UNLookupModal/UNLookupModal';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { RootState } from '../../../../../setup/redux/RootReducer';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { KTSVG } from '../../../../../_metronic/helpers';
import ShippingItemsModal from '../ShippingItemsModal';
import FreightSnapAction from '../FreightSnap/FreightSnapAction';
import { actionTypes } from '../../../../modules/auth/redux/PagesRedux';
import { SelectStyled, TextFieldStyled, NumberFormatStyled, InputStyled } from '../../../Inputs.styled';
import { PaperStyled } from '../../LTLAndVolumeTLPages.styled';
import { makeStyles } from '@mui/styles';
import { stylesMUIInput } from '../../../stylesMUIInput';
import { quoteValuesModel } from '../../../PagesModels';
import InputMask from  'react-input-mask'
import NMFCLookupModal from '../../NMFCLookupModal/NMFCLookupModal';
import axios from 'axios';
import { checkErrorAPICall } from '../../../../helpers/checkErrorAPICall';
import RequireClassITModal from '../../NMFCTable/RequireClassITModal';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { enableSplashScreen } from '../../../../../_metronic/layout/core';

const GET_NMFCS = 'api/v1/database/nmfc/search'
const GET_LNFT = '/api/v1/tools/lnft'
let cancelToken


const FreightInformation = React.memo(({setDataFormik, freightInfo, index, freight, freightInfoUOM, handleChange, formik, errors, touched, disabled, freightForNewBooking, formikValues, setOpenClearRateToEditModal, formikDispatch, dispatchShip, mode, setOpenHazContactModal, setSelectedUn, selectedUn, formDisabled, setNewValuesWhenRateCleared, overrideLength}: FreightInformationProps) => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const hazEnabled = user.enabledAccessorials.find(accessorial => accessorial.code === 'HAZ')
    const [densityOptions, setDensityOptions] = useState([])
    const [openUNModal, setOpenUNModal] = useState(false)
    const [openNMFCModal, setOpenNMFCModal] = useState(false)
    const [openShippingItemsModal, setOpenShippingItemsModal] = useState(false)
    const [typeLocal, setTypeLocal] = useState('')
    const [loadingNMFC, setLoadingNMFC] = useState(false)
    const [openRequireClassITModal, setOpenRequireClassITModal] = useState(false)
    const [classSelectedManually, setClassSelectedManually] = useState(false)
    const [searchUNTable, setSearchUNTable] = useState('')
    const props = {
        fontSize: fontSize,
        disabled: !user?.allowClassSelection,
    }
    const classes = useStyles(props)
    const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any
    const quoteValues = useSelector<RootState>(({pages}) => pages.quoteValues) as quoteValuesModel
    const historyUsed = useSelector<RootState>(({pages}) => pages.historyUsed)
    const dispatch = useDispatch()

    const clearFreightSnapRef = () => {
        if(freight?.freightsnapId){
            setDataFormik(`freightInfo[${index}].freightsnapId`, null)
            dispatch({type: actionTypes.SetAxiosSuccess, payload: 'FreightSnap scan removed because the dimensions were edited.'})
        }
    }

    const useHeightStyles = makeStyles({
        height: {
            height: fontSize === 9 ? '30px' : fontSize === 11 ? '40px' : 'var(--input-height)',
        }
    })
    const classesHeight = useHeightStyles()

    const poundsForEver = (value, valueType = '', freightInfoUOM) => {
        if (freightInfoUOM.value === 'US'){
            return parseFloat(value)
        } else {
            return parseFloat(valueType === 'weight' ? (value/0.45359237).toString() : (value/2.54).toString())
        }
    }

    const calculateVolume = (freightInfoItem) => {
        if (freightInfoItem.qty > 0 && freightInfoItem.L > 0 && freightInfoItem.W > 0 && freightInfoItem.H > 0) {
            let QTY = parseInt(freightInfoItem.qty);
            let L = parseFloat(freightInfoItem.L);
            let W = parseFloat(freightInfoItem.W);
            let H = parseFloat(freightInfoItem.H);
            let cubic = L * W * H;
    
            if (freightInfoUOM.value !== 'US') {
                cubic /= 1000000; // m3
            } else {
                cubic /= 1728; // ft3
            }
    
            return (cubic * QTY).toFixed(2);
        } else {
            return freightInfoItem.volume;
        }
    }
    
    const addNewFreight = () => {
        const newData = {
            id: uuidv4(), 
            overrideClass: true,
            qty: '',
            dimType:  newBookingValues?.freightInfo[0]?.dimType || {
                name: "PALLET",
                value: "PLT"
            },
            L: newBookingValues?.freightInfo[0]?.L || '',
            W: newBookingValues?.freightInfo[0]?.W || '',
            H: newBookingValues?.freightInfo[0]?.H || '',
            commodity: newBookingValues?.freightInfo[0]?.commodity || '',
            STC: '',
            weight: '',
            each: 'Each',
            class: '',
            nmfc: '',
            weightus: '',
            Lus: newBookingValues?.freightInfo[0]?.L || '',
            Wus: newBookingValues?.freightInfo[0]?.W || '',
            Hus: newBookingValues?.freightInfo[0]?.H || '',
            stack: null,
            totalCft: '',
            hazmat: false,
            UN: '',
            volume: '',
        }
        const freightNewArray = [...freightInfo, newData]
        setDataFormik('freightInfo', freightNewArray)
    }

    const removeFreight = (id) => {
        let newArray = freightInfo.filter(data => data.id !== id)
        setDataFormik('freightInfo', newArray)
    }

    useEffect(() => {
        // Calc the CFT
        if(freight.qty && (freight.Lus || freight.Wus || freight.Hus) && freight.weight){
            let L = freight.Lus
            let H = freight.Hus
            let W = freight.Wus
            let locals = parseInt(freight.qty)*(Number(L)*Number(W)*Number(H)/1728)
            setDataFormik(`freightInfo[${index}].totalCft`, locals)
            calculateClass(locals)
        }
        else if(freight.qty && freight.volume) {
            calculateClass(false, false ,freight.volume)
        }

        // Calc the Volume
        setDataFormik(`freightInfo[${index}].volume`, calculateVolume(freight))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [freight.L, freight.Lus, freight.H, freight.Hus, freight.W, freight.Wus, freight.qty, freight.each, freight.weight, freight.weightus, freight.volume])

    useEffect(() => {
        let arrayOfDensities = user?.densityRules?.map(density => density.class)
        setDensityOptions(arrayOfDensities.sort((a, b) => parseFloat(a) - parseFloat(b)))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.densityRules])
 
    const calculateClass = (locals, weight, volume) => {
        let localDensity = 0
        if(locals ? locals : freight.totalCft){
            if(weight ? weight : freight.weight){
                localDensity = _.ceil((freight.each === 'Each')
                ? (parseInt(weight ? weight : freight.weightus)*parseInt(freight.qty))/parseFloat(locals ? locals : freight.totalCft)
                : parseFloat(weight ? weight : freight.weightus)/parseFloat(locals ? locals : freight.totalCft), 2) 
            }
        }

        if(volume) {
            localDensity = _.ceil((freight.each === 'Each')
                ? (parseInt(weight ? weight : freight.weightus)*parseInt(freight.qty))/ _.ceil(parseFloat(volume), 2)
                : parseFloat(weight ? weight : freight.weightus)/_.ceil(parseFloat(volume), 2))
        }

        let densityRulesSorted = user?.densityRules?.sort((a, b) => parseFloat(a.class) - parseFloat(b.class))

        densityRulesSorted?.forEach((density) => {
            let from = density.densityFrom
            let to = density.densityTo

                    if(localDensity >= from && (to !== -1 ? localDensity < to : true)){
                        if(!historyUsed){
                            if(formik.values.freightInfo[index].overrideClass !== false && !formik.values.freightInfo[index].classModified){
                                setDataFormik(`freightInfo[${index}].class`, density.class)
                            }
                        }
                    }
                })
        }

    /* useEffect(()=> {
        // Compute Class Select Element of Local Density
        if(freight.totalCft){
            if(freight.weight){
                let localDensity = _.ceil((freight.each === 'Each') ? (parseInt(freight.weightus)*parseInt(freight.qty))/parseFloat(freight.totalCft) : parseFloat(freight.weightus)/parseFloat(freight.totalCft), 2) 

                let densityRulesSorted = user?.densityRules?.sort((a, b) => parseFloat(a.class) - parseFloat(b.class))

                densityRulesSorted?.forEach((density) => {
                    let from = density.densityFrom
                    let to = density.densityTo

                    if(localDensity >= from && (to !== -1 ? localDensity < to : true)){
                        if(!historyUsed){
                            if(formik.values.freightInfo[index].overrideClass !== false){
                                setDataFormik(`freightInfo[${index}].class`, density.class)
                            }
                        }
                    }
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [freight.totalCft, freight.weight, freight.each]) */

    useEffect(()=> {
            let UNIndex = freightInfo.findIndex(freightInfoUN => freightInfoUN?.UN === selectedUn?.UNNumber)
            if(freight?.UN){                
                setDataFormik(`freightInfo[${UNIndex}].UNPKGGroup`, selectedUn?.PKGGroup)                    
            }
            else if(!selectedUn?.PKGGroup) {
                setDataFormik(`freightInfo[${UNIndex}].UNPKGGroup`, '')
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [freight?.UN, selectedUn?.PKGGroup])

    const hasChanged = (property) => {
        let value = formik?.values?.freightInfo[index]&&[property]
        let initialValue = formik?.initialValues&&[property]

        return _.isEqual(value, initialValue)
    }

    const hasFreightFieldError = (field) => {
        const touchedError = errors?.[field] && touched?.[field] && hasChanged(field)
        const dispatchError = dispatchShip && formikDispatch?.errors?.freightInfo?.[index]?.[field]
        return touchedError || dispatchError
    }

    const getFreightFieldErrorMessage = (field) => {
        if (errors?.[field] && touched?.[field] && hasChanged(field)) {
            return errors[field]
        }
        if (dispatchShip && formikDispatch?.errors?.freightInfo?.[index]?.[field]) {
            return formikDispatch?.errors?.freightInfo?.[index]?.[field] || 'Required'
        }
        return null
    }

    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }

    const formatNMFC = (value, isBlur = false) => {
        if(!value){
            return value
        }
        
        if(isBlur){
            // En blur: formatear según si tiene guión o no
            if(value.includes('-')){
                let parts = value.split('-')
                let firstPart = parts[0].replace(/\D/g, '')
                let secondPart = parts[1].replace(/\D/g, '')
                
                // Primeros 6 dígitos con ceros a la izquierda
                firstPart = firstPart.padStart(6, '0')
                // Últimos 2 dígitos con ceros a la izquierda también
                secondPart = secondPart.padStart(2, '0')
                
                return firstPart + '-' + secondPart
            } else {
                // Sin guión: extraer solo dígitos, completar a 6 dígitos con ceros a la izquierda, agregar -00
                let digitsOnly = value.replace(/\D/g, '')
                if(digitsOnly){
                    let paddedValue = digitsOnly.padStart(6, '0')
                    return paddedValue + '-00'
                }
                return value
            }
        }
        
        // Mientras se tipea: permitir escritura normal
        return value
    }
    
    useEffect(() => {
        if(overrideLength){
            const qty = formik.values.freightInfo.map((f) => f.qty).filter(f => f !== '' && f !== 0)
            const L = formik.values.freightInfo.map((f) => f.L).filter(f => f !== '' && f !== 0)
            const W = formik.values.freightInfo.map((f) => f.W).filter(f => f !== '' && f !== 0)
            const H = formik.values.freightInfo.map((f) => f.H).filter(f => f !== '' && f !== 0)

            if((qty.length === formik.values.freightInfo.length) && (L.length === formik.values.freightInfo.length) && (W.length === formik.values.freightInfo.length) && (H.length === formik.values.freightInfo.length)){
                if (typeof cancelToken != typeof undefined) {
                    cancelToken.cancel('Operation canceled due to new request.')
                }
            
                cancelToken = axios.CancelToken.source()
        
                axios.get(GET_LNFT, {
                    cancelToken: cancelToken.token,
                    params: {
                        returnLayout: false,
                        companyDefaultTruck: true,
                        freightInfo: JSON.stringify(
                        formik.values.freightInfo.map((freight: any) => {
                            return {
                            qty: parseFloat(freight.qty),
                            weight: parseFloat(freight.weight),
                            weightType: freight.each === "Each" ? "each" : "total",
                            length: parseFloat(freight.L),
                            width: parseFloat(freight.W),
                            height: parseFloat(freight.H),
                            class: parseFloat(freight.class) || 0,
                            hazmat: freight.hazmat,
                            stack: false,
                            }
                        })
                        ),
                        UOM: formik.values.freightInfoUOM?.value,
                    }
                })
                .then(results => {
                    formik.setFieldValue(`stops.length`, results.data.data.results.LNFT)
                })
            }
        }
    }, [formik.values.freightInfo.length, freight.qty, freight.L,  freight.W, freight.H])

    return (
        <>
            <DivContainerStyled>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div style={{flex: 0.3}} className="me-2 d-flex align-items-center mt-4">
                    <IconButton
                        onClick={() => {
                            if(!formDisabled){
                                setOpenShippingItemsModal(true)
                            }else{
                                setOpenClearRateToEditModal(true)
                            }
                        }}
                        disabled={disabled}>
                        <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon fs-9' style={{ color: "#5E6278"}}/>
                    </IconButton>
                </div>
                <div style={{flex: 1, minWidth: 60}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <NumberFormatStyled
                        disabled={disabled}
                        placeholder="QTY"
                        className={hasFreightFieldError('qty') ? `form-control form-control-error ${disabled && 'disabled'}` : `form-control ${disabled && 'disabled'}`}
                        autoComplete="off"
                        value={freight.qty}
                        name={`freightInfo[${index}].qty`}
                        allowNegative={false}
                        onChange={(e) => {
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        qty: parseInt(e.target.value.replace(/,/g, '')) || ''
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            if(!e.target.value && overrideLength){
                                formik.setFieldValue(`stops.length`, '')
                            }
                            
                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].qty`,
                                    value: parseInt(e.target.value.replace(/,/g, '')) || ''
                                }
                            })
                        }}
                        thousandSeparator={','}
                        decimalScale={0}
                        isAllowed={(values) => {
                            const { formattedValue, floatValue } = values;
                            return formattedValue === '' || (floatValue >= 0 && floatValue <= 99)
                        }}
                        onBlur={() => formik.setFieldTouched(`freightInfo[${index}].qty`, true)}
                        fontSize={fontSize}
                    />
                    {getFreightFieldErrorMessage('qty')
                        ? <small className="text-danger">{getFreightFieldErrorMessage('qty')}</small>
                        : null
                    }
                </div>
                <div style={{flex: 1, minWidth: 75, maxWidth: 75}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <Autocomplete
                        isOptionEqualToValue={(option, value) => option?.name === value?.name}
                        inputValue={typeLocal || ""}
                        value={freight.dimType || {name: "PALLET", value: "PLT"}}
                        options={TypeOptions || []}
                        disabled={disabled}
                        autoSelect
                        disableClearable
                        autoComplete={false}
                        autoHighlight={true}
                        className={classes.selectMUI}
                        onChange={(e, value) => {
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        dimType: value
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            formik.setFieldValue(`freightInfo[${index}].dimType`, value)
                        }}
                        onInputChange={(e, value) => {
                            setTypeLocal(value || "")
                        }}
                        renderOption={(props,option) => {
                            return (
                                <li {...props}>{option.name}</li>
                            )
                        }}
                        getOptionLabel={(option) => option?.value || ""}
                        style={{
                            fontSize: '14px !important',
                            fontFamily: 'Poppins !important',
                            fontWeight: '500 !important',
                            background: 'white',
                            color: "#5E6278",
                            height: fontSize === 9 ? '30px' : fontSize === 11 ? '40px' : 'var(--input-height)'
                        }}
                        popupIcon={<KeyboardArrowDownIcon />}
                        readOnly={formDisabled ? true : false}
                        renderInput={(params) => {
                            return <TextFieldStyled
                                {...params}
                                label=" "
                                InputLabelProps={{shrink: false}}
                                InputProps={{
                                    ...params.InputProps,
                                    className: classesHeight.height,
                                    style: {fontSize: 14, fontFamily: 'Poppins', fontWeight: 500, paddingRight: 9, color:"#5E6278 !important", borderTopLeftRadius: 0, borderBottomLeftRadius: 0}
                                }}
                            />
                        }}
                        PaperComponent={({ children }) => (
                            <PaperStyled fontSize={fontSize} paddingsmall='true' style={{width: 100}}>
                                {children}
                            </PaperStyled>
                        )}
                        noOptionsText={<div style={{fontWeight: 500, color: "#a1a5b6"}}>No options</div>}
                    />
                </div>
                <div style={{flex: 1, minWidth: 100}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <InputStyled
                        disabled={disabled}
                        className={`form-control ${disabled && 'disabled'}`}
                        type="text"
                        autoComplete='off'
                        placeholder="STC"
                        value={freight.STC}
                        onChange={(e) => {
                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].STC`,
                                    value: e.target.value
                                }
                            })
                        }}
                        name={`freightInfo[${index}].STC`}
                        fontSize={fontSize}
                        readOnly={formDisabled ? true : false}
                       
                    />
                </div>
                <div style={{flex: 3, minWidth: 100}} className="me-2 mb-2 mb-xl-0 mt-4">
                	<Tooltip title={freight?.commodity || ''}>
	                    <InputStyled
	                        disabled={disabled}
	                        type="text"
	                        autoComplete='off'
	                        placeholder="COMMODITY"
	                        value={freight?.commodity}
	                        onChange={(e) => {
                                handleChange({
                                    ...e,
                                    target: {
                                        name: `freightInfo[${index}].commodity`,
                                        value: e.target.value
                                    }
                                })
                            }}
	                        name={`freightInfo[${index}].commodity`}
	                        className={`form-control ${disabled && 'disabled'}`}
	                        fontSize={fontSize}
	                        maxLength={150}
	                        error={dispatchShip ? formikDispatch?.errors?.freightInfo?.length && formikDispatch?.errors?.freightInfo[index]?.commodity : ''}
	                        readOnly={formDisabled ? true : false}
	                    />
	                </Tooltip>
                    {dispatchShip && formikDispatch?.errors?.freightInfo?.length && formikDispatch?.errors?.freightInfo[index]?.commodity ? <small className="text-danger mt-1">Required</small> : null}
                </div>
                <div style={{flex: 1.2, minWidth: 80, maxWidth: 80}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <NumberFormatStyled
                        disabled={disabled}
                        type="tel"
                        className={hasFreightFieldError('weight') ? `form-control form-control-error ${disabled && 'disabled'}` : `form-control ${disabled && 'disabled'}`}
                        placeholder="Weight"
                        autoComplete="off"
                        // value={freight.weight ? _.round(Number(freight.weight)) : ''}
                        value={freight.weight ? freight.weight : ''}
                        name={`freightInfo[${index}].weight`}
                        allowNegative={false}
                        onChange={(e) => {
                            clearFreightSnapRef()
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        weight: e.target.value ? parseFloat(e.target.value?.replace(",", "")) : ''
                                    },
                                    functionToDo: () => {
                                        calculateClass()
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].weight`,
                                    value: parseFloat(e.target.value.replace(/,/g, '')) || ''                                    
                                }
                            })
                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].weightus`,
                                    value: poundsForEver(parseFloat(e.target.value.replace(/,/g, '')), 'weight', freightInfoUOM)
                                }
                            })
                            // calculateClass(undefined, e.target.value)
                        }}
                        thousandSeparator={','}
                        decimalSeparator={'.'}
                        isAllowed={(values) => {
                            const { formattedValue, floatValue } = values;
                            return formattedValue === '' || (floatValue >= 0 && floatValue <= 99999)
                        }}
                        fontSize={fontSize}
                                                
                        onBlur={() => {
                            if(freight.weight?.toString().includes('.')) {
                                formik.setFieldValue(`freightInfo[${index}].weight`, parseFloat(freight.weight.toFixed(2)) || '')
                                formik.setFieldTouched(`freightInfo[${index}].weight`, true)
                            }
                        }}
                    />
                    {getFreightFieldErrorMessage('weight')
                        ? <small className="text-danger">{getFreightFieldErrorMessage('weight')}</small>
                        : null
                    }
                </div>
                <div style={{flex: 1, minWidth: 100}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <TextFieldStyled
                        disabled={disabled}
                        select
                        label=" "
                        value={freight.each || 'Each'}
                        onChange={(e) => {
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        each: e.target.value
                                    },
                                    functionToDo: () => {
                                        calculateClass()
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].each`,
                                    value: e.target.value
                                }
                            })
                            calculateClass()
                        }}
                        name={`freightInfo[${index}].each`}
                        className={classes.selectMUI}
                        InputProps={{
                            style: stylesMUIInput(fontSize),
                            readOnly: formDisabled ? true : false
                        }}
                        SelectProps={{
                            IconComponent: KeyboardArrowDownIcon,
                            MenuProps: menuProps
                        }}
                        InputLabelProps={{shrink: false}}
                    >
                        <MenuItem value="Each">Each</MenuItem>
                        <MenuItem value="Total">Total</MenuItem>
                    </TextFieldStyled>
                </div>
                <div style={{flex: 1, minWidth: 50}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <NumberFormatStyled
                        disabled={disabled}
                        placeholder="L"
                        className={hasFreightFieldError('L') ? `form-control form-control-error ${disabled && 'disabled'}` : `form-control ${disabled && 'disabled'}`}
                        autoComplete="off"
                        // value={freight.L ? _.round(Number(freight.L)) : ''}
                        value={freight.L ? freight.L : ''}
                        name={`freightInfo[${index}].L`}
                        allowNegative={false}
                        onChange={(e) => {
                            clearFreightSnapRef()
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        LFormatted: parseFloat(e.target.value.replace(/,/g, '')) || '',
                                        L: parseFloat(e.target.value.replace(/,/g, '')) || ''
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }
                            
                            if(!e.target.value && overrideLength){
                                formik.setFieldValue(`stops.length`, '')
                            }

                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].L`,
                                    value: parseFloat(e.target.value.replace(/,/g, '')) || ''
                                }
                            })
                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].Lus`,
                                    value: poundsForEver(parseFloat(e.target.value.replace(/,/g, '')), 'L', freightInfoUOM) || ''
                                }
                            })
                        }}
                        thousandSeparator={','}
                        isAllowed={(values) => {
                            const { formattedValue, floatValue } = values;
                            return formattedValue === '' || (floatValue >= 0 && floatValue <= 99999)
                        }}
                        fontSize={fontSize}
                        onBlur={() => {
                            if(freight.L?.toString().includes('.')){
                                formik.setFieldValue(`freightInfo[${index}].L`, parseFloat(freight.L.toFixed(2)) || '')
                                formik.setFieldTouched(`freightInfo[${index}].L`, true)
                            }
                        }}
                    />
                    {getFreightFieldErrorMessage('L')
                        ? <small className="text-danger">{getFreightFieldErrorMessage('L')}</small>
                        : null
                    }
                </div>
                <div style={{flex: 1, minWidth: 50}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <NumberFormatStyled
                        disabled={disabled}
                        placeholder="W"
                        className={hasFreightFieldError('W') ? `form-control form-control-error ${disabled && 'disabled'}` : `form-control ${disabled && 'disabled'}`}
                        autoComplete="off"
                        // value={freight.W ? _.round(Number(freight.W)) : ''}
                        value={freight.W ? freight.W : ''}
                        name={`freightInfo[${index}].W`}
                        allowNegative={false}
                        onChange={(e) => {
                            clearFreightSnapRef()
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        WFormatted: parseFloat(e.target.value.replace(/,/g, '')) || '',
                                        W: parseFloat(e.target.value.replace(/,/g, '')) || ''
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            if(!e.target.value && overrideLength){
                                formik.setFieldValue(`stops.length`, '')
                            }

                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].W`,
                                    value: parseFloat(e.target.value.replace(/,/g, '')) || ''
                                }
                            })
                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].Wus`,
                                    value: poundsForEver(parseFloat(e.target.value.replace(/,/g, '')), 'W', freightInfoUOM) || ''
                                }
                            })
                        }}
                        thousandSeparator={','}
                        isAllowed={(values) => {
                            const { formattedValue, floatValue } = values;
                            return formattedValue === '' || (floatValue >= 0 && floatValue <= 99999)
                        }}
                        style={{height: fontSize === 9 ? '30px' : fontSize === 11 ? '40px' : 'var(--input-height)'}}
                        fontSize={fontSize}
                        onBlur={() => {
                            if(freight.W?.toString().includes('.')){
                                formik.setFieldValue(`freightInfo[${index}].W`, parseFloat(freight.W.toFixed(2)) || '')
                                formik.setFieldTouched(`freightInfo[${index}].W`, true)
                            }
                        }}
                    />
                    {getFreightFieldErrorMessage('W')
                        ? <small className="text-danger">{getFreightFieldErrorMessage('W')}</small>
                        : null
                    }
                </div>
                <div style={{flex: 1, minWidth: 50}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <NumberFormatStyled
                        disabled={disabled}
                        placeholder="H"
                        className={hasFreightFieldError('H') ? `form-control form-control-error ${disabled && 'disabled'}` : `form-control ${disabled && 'disabled'}`}
                        autoComplete="off"
                        // value={freight.H ? _.round(Number(freight.H)) : ''}
                        value={freight.H ? freight.H : ''}
                        name={`freightInfo[${index}].H`}
                        allowNegative={false}
                        onChange={(e) => {
                            clearFreightSnapRef()
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        HFormatted: parseFloat(e.target.value.replace(/,/g, '')) || '',
                                        H: parseFloat(e.target.value.replace(/,/g, '')) || ''
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            if(!e.target.value && overrideLength){
                                formik.setFieldValue(`stops.length`, '')
                            }

                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].H`,
                                    value: parseFloat(e.target.value.replace(/,/g, '')) || ''
                                }
                            })
                            handleChange({
                                ...e,
                                target: {
                                    name: `freightInfo[${index}].Hus`,
                                    value: poundsForEver(parseFloat(e.target.value.replace(/,/g, '')), 'H', freightInfoUOM) || ''
                                }
                            })
                        }}
                        thousandSeparator={','}
                        isAllowed={(values) => {
                            const { formattedValue, floatValue } = values;
                            return formattedValue === '' || (floatValue >= 0 && floatValue <= 99999)
                        }}
                        fontSize={fontSize}
                        onBlur={() => {
                            if(freight.H?.toString().includes('.')){
                                formik.setFieldValue(`freightInfo[${index}].H`, parseFloat(freight.H.toFixed(2)) || '')
                                formik.setFieldTouched(`freightInfo[${index}].H`, true)
                            }
                        }}
                    />
                    {getFreightFieldErrorMessage('H')
                        ? <small className="text-danger">{getFreightFieldErrorMessage('H')}</small>
                        : null
                    }
                </div>
                <div style={{flex: 1, minWidth: 70, maxWidth: 70}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <FormControl fullWidth>
                        <InputLabel sx={{color: 'rgb(94, 98, 120)', top: '-7px', left: '-7px', fontSize: '11px', '&.MuiInputLabel-shrink' : { color: '#5E6278', left:'-11px', top: '-5px' } }} id="stack-select-label">STACK</InputLabel>
                        <SelectStyled
                            disabled={!user?.showStackOptions || disabled}
                            value={parseInt(freight.stack) ? freight.stack : 'No'}
                            name={`freightInfo[${index}].stack`}
                            onChange={(e) => {
                                if(formikValues?.carrierInformation?.name || formDisabled){
                                    setNewValuesWhenRateCleared({
                                        valuesFor: `freightInfo[${index}]`,
                                        originalValues: formik.values.freightInfo[index],
                                        values: {
                                            ...formik.values.freightInfo[index],
                                            stack: e.target.value
                                        }
                                    })
                                    setOpenClearRateToEditModal(true)
                                }
    
                                handleChange({
                                    ...e,
                                    target: {
                                        name: `freightInfo[${index}].stack`,
                                        value: e.target.value
                                    }
                                })
                            }}
                            className={classes.select}
                            displayEmpty={true}
                            labelId="stack-select-label"
                            id="stack-select"
                            renderValue={value => value?.length ? value : 'No'}                        
                            label="Stack"
                            inputProps={{
                                IconComponent: KeyboardArrowDownIcon,
                                MenuProps: menuProps,
                                style: stylesMUIInput(fontSize),
                            }}
                            style={{
                                color: freight.stack !== 'No' && freight.stack ? '#5E6278' : '#A1A5B6',
                            }}
                            fontSize={fontSize}
                            
                    >
                            {
                                ['No', '2', '3', '4', '5', '6', '7', '8', '9']?.map((stack, index) => {
                                    return <MenuItem key={index} value={stack}>{stack}</MenuItem>
                                })
                            }
                        </SelectStyled>
                    </FormControl>
                </div>
                <div style={{flex: 1, minWidth: 80, maxWidth: 80}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <InputStyled
                        disabled={disabled}
                        type="number"
                        autoComplete="off"
                        placeholder="VOL"
                        value={freight.volume}
                        onChange={(e) => {
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        volume: e.target.value
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            handleChange(e)
                        }}
                        name={`freightInfo[${index}].volume`}
                        className={`form-control ${disabled && 'disabled'}`}
                        fontSize={fontSize}
                    />
                </div>
                <div style={{flex: 1, minWidth: fontSize <= 13 ? 90 : 110, maxWidth: fontSize <= 13 ? 90 : 110}} className="me-2 mb-2 mb-xl-0 mt-4">
                    <SelectStyled
                        disabled={!user?.allowClassSelection || disabled}
                        value={freight.class ? parseInt(freight.class).toString() : ''}
                        name={`freightInfo[${index}].class`}
                        onChange={(e) => {
                            if(formikValues?.carrierInformation?.name || formDisabled){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        class: e.target.value,
                                        overrideClass: false
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            formik.setFieldValue(`freightInfo[${index}].overrideClass`, false)
                            handleChange(e)
                        }}
                        className={classes.select}
                        displayEmpty={true}
                        renderValue={value => value?.length ? parseInt(value).toString() : 'CLS'}
                        inputProps={{
                            IconComponent: KeyboardArrowDownIcon,
                            MenuProps: menuProps,
                            style: stylesMUIInput(fontSize),
                        }}
                        style={{
                            color: freight.class ? '#5E6278' : '#A1A5B6',
                        }}
                        fontSize={fontSize}
                    >
                        {
                            densityOptions?.map((density, index) => {
                                return <MenuItem key={index} value={density}>{density}</MenuItem>
                            })
                        }
                    </SelectStyled>
                </div>
                <div style={{flex: 2, minWidth: 100, maxWidth: 140}} className='mt-4'>
                    <InputMask
                        onChange={(e) => {
                            const formattedValue = e.target.value
                            
                            if((formikValues?.carrierInformation?.name || formDisabled) && formikValues.freightInfo[index].nmfc && e.target.value === '      -  '){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        nmfc: formattedValue
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }
                            if((formikValues?.carrierInformation?.name || formDisabled) && formattedValue !== '' && e.target.value.includes('-')){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfo[${index}]`,
                                    originalValues: formik.values.freightInfo[index],
                                    values: {
                                        ...formik.values.freightInfo[index],
                                        nmfc: formattedValue
                                    }
                                })
                                setOpenClearRateToEditModal(true)
                            }

                            // Solo actualizar sin formatear mientras se tipea
                            formik.setFieldValue(`freightInfo[${index}].nmfc`, formattedValue)
                        }}
                        value={freight.nmfc}
                        mask="999999-99"
                        maskPlaceholder={null}
                        maskChar={null}
                        disabled={disabled}
                        onBlur={(e) => formik.setFieldValue(`freightInfo[${index}].nmfc`, formatNMFC(e.target.value, true))}
                    >
                        {() => <TextField
                            name={`freightInfo[${index}].nmfc`}
                            autoComplete="off"
                            className={errors?.nmfc && touched?.nmfc && hasChanged('nmfc') ? classes.textFieldError : classes.textFieldMUIWithoutBorder}
                            placeholder="NMFC"
                            onKeyDown={(e) => {
                                if((e.key === 'Enter') && /\d/.test(e.target.value)){
                                    e.preventDefault()
                                    setLoadingNMFC(true)
                                    formik.setFieldValue(`freightInfo[${index}].nmfc`, formatNMFC(e.target.value))

                                    if(user?.allowClassIT){
                                        axios.get(GET_NMFCS, {
                                            params: {
                                                keyword: formatNMFC(e.target.value)
                                            }
                                        }).then(response => {
                                            let NMFC = response.data.data.results?.NMFCCodes[0]
                                            if(NMFC?.itemNumber === formatNMFC(e.target.value)){
                                                if(!NMFC?.itemClass || NMFC.itemClass === '-') {
                                                    formik.setFieldValue(`freightInfo[${index}].class`, '')
                                                    formik.setFieldValue(`freightInfo[${index}].commodity`, '')
                                                    return
                                                }
                                                formik.setFieldValue(`freightInfo[${index}].nmfc`, NMFC?.itemNumber)
                                                formik.setFieldValue(`freightInfo[${index}].class`, NMFC?.itemClass)
                                                formik.setFieldValue(`freightInfo[${index}].commodity`, NMFC?.itemDescription)
                                                formik.setFieldValue(`freightInfo[${index}].overrideClass`, false)
                                            }
                                        }).catch(error => {
                                            if(error?.response?.data?.error?.message === 'Empty classIT credentials.'){
                                                setOpenRequireClassITModal(true)
                                                setLoadingNMFC(false)
                                            }else{  
                                                checkErrorAPICall(error, dispatch, 'NMFC Numbers')
                                            }
                                        }).finally(() => {
                                            setLoadingNMFC(false)
                                        })
                                    }
                                }
                            }}
                            InputProps={{
                                endAdornment: (
                                    <>
                                        {
                                            user?.allowClassIT ? 
                                            <InputAdornment position="end" style={{margin: 0}}>
                                                <IconButton
                                                    disabled={disabled || loadingNMFC}
                                                    onClick={(e) => {
                                                        formik.setFieldValue(`freightInfo[${index}].nmfcSearch`, formik.values?.freightInfo[index].nmfc)
                                                        setOpenNMFCModal(true)
                                                    }}>
                                                    {loadingNMFC ? <div className='d-flex align-items-center'><CircularProgress color="inherit" size={15} /></div> : <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon fs-9' style={{ color: !disabled ? "#5E6278" : 'rgba(0, 0, 0, 0.23)'}}/>}
                                                </IconButton>
                                            </InputAdornment>
                                            : null
                                        }
                                    </>
                                ),
                                style: stylesMUIInput(fontSize)
                            }}
                        />}
                    </InputMask>
                </div>
                {
                    hazEnabled ?
                    <>
                        <div style={{flex: 0.5, minWidth: 40, maxWidth: 40}} className="me-2 mb-2 mb-xl-0 d-flex align-items-center justify-content-center">
                            <div className="form-check form-check-custom form-check-solid form-check-sm d-flex flex-column">
                                <label style={{cursor: disabled ? 'default' : 'pointer'}} htmlFor={index.toString()}>
                                    Haz
                                </label>
                                <input
                                    disabled={disabled || formDisabled}
                                    className="form-check-input white-bg"
                                    type="checkbox"
                                    onChange={(e) => {
                                        if(formikValues?.carrierInformation?.name || formDisabled){
                                            setNewValuesWhenRateCleared({
                                                valuesFor: `freightInfo[${index}]`,
                                                originalValues: formik.values.freightInfo[index],
                                                values: {
                                                    ...formik.values.freightInfo[index],
                                                    hazmat: e.target.checked,
                                                    UN: e.target.checked === false ? '' : formik.values.freightInfo[index].UN
                                                }
                                            })
                                            setOpenClearRateToEditModal(true)
                                        }

                                        handleChange(e)
                                        if(e.target.checked === false){
                                            setSelectedUn([])
                                            setDataFormik(`freightInfo[${index}].UN`, "")
                                        }
                                    }}
                                    checked={freight.hazmat}
                                    name={`freightInfo[${index}].hazmat`}
                                    id={index.toString()}
                                />
                            </div>
                        </div>                        
                        {/* <div style={{flex: 1.3, minWidth: 100, maxWidth: 100}} className="me-2 mb-2 mb-xl-0 mt-md-4">                            
                                <NumberFormatStyled
                                    name={`freightInfo[${index}].UN`}
                                    onChange={handleChange}
                                    customInput={TextField}
                                    isAllowed={(values) => {
                                        const { formattedValue, floatValue } = values;
                                        return formattedValue === '' || (floatValue >= 0 && floatValue <= 9999)
                                    }}
                                    allowNegative={false}
                                    disabled={!freight.hazmat || disabled}
                                    autoComplete="off"
                                    className={classes.textFieldMUIWithoutBorder}
                                    placeholder="UN#"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" style={{margin: 0}}>
                                                <IconButton disabled={!freight.hazmat || disabled} onClick={() => setOpenUNModal(true)}>
                                                    <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon fs-9' style={{ color: freight.hazmat && !disabled ? "#5E6278" : 'rgba(0, 0, 0, 0.23)'}}/>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        style: stylesMUIInput(fontSize)
                                    }}
                                    value={freight.UN}
                                    fontSize={fontSize}
                                />
                            </div> */}
                        
                        <div style={{flex: 1.3, minWidth: 100, maxWidth: 100}} className="me-2 mb-2 mb-xl-0 mt-4">                                                       
                            <NumberFormatStyled
                                name={`freightInfo[${index}].UN`}
                                onChange={(e) => {
                                    if(formikValues?.carrierInformation?.name || formDisabled){
                                        setNewValuesWhenRateCleared({
                                            valuesFor: `freightInfo[${index}]`,
                                            originalValues: formik.values.freightInfo[index],
                                            values: {
                                                ...formik.values.freightInfo[index],
                                                UN: e.target.value
                                            }
                                        })
                                        setOpenClearRateToEditModal(true)
                                    }

                                    handleChange(e)
                                    setSearchUNTable(e.target.value)
                                    if(!e.target.value){
                                    	setSelectedUn([])
                                    }
                                }}
                                customInput={TextField}
                                isAllowed={(values) => {
                                    const { formattedValue, floatValue } = values;
                                    return formattedValue === '' || (floatValue >= 0 && floatValue <= 9999)
                                }}
                                allowNegative={false}
                                disabled={!freight.hazmat || disabled}
                                autoComplete="off"
                                className={classes.textFieldMUIWithoutBorder}
                                placeholder="UN#"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" style={{margin: 0}}>
                                            <IconButton
                                                disabled={!freight.hazmat || disabled}
                                                onClick={() => {
                                                    if(formikValues?.carrierInformation?.name || formDisabled){
                                                        setOpenClearRateToEditModal(true)
                                                    }else{
                                                        setOpenUNModal(true)
                                                    }
                                                }}
                                            >
                                                <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon fs-9' style={{ color: freight.hazmat && !disabled ? "#5E6278" : 'rgba(0, 0, 0, 0.23)'}}/>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    style: stylesMUIInput(fontSize),
                                    readOnly: formDisabled ? true : false
                                }}
                                value={freight.UN}
                                fontSize={fontSize}
                            />
                        </div>
                    </>
                    : null
                }
                {
                    formik.values.stops?.stops?.length ?
                        <div style={{flex: 1.3, minWidth: 190, maxWidth: 190}} className={`me-2 mb-2 mb-xl-0 mt-md-4 ${!hazEnabled ? 'ms-2' : ''}`}>
                            <SelectStyled
                                defaultValue=""
                                disabled={disabled}
                                value={formik.values.freightInfo[index].stopNumber || ''}
                                onChange={handleChange}
                                name={`freightInfo[${index}].stopNumber`}
                                className={classes.select}
                                displayEmpty={true}
                                readOnly={formDisabled ? true : false}
                                onClick={() => {
                                    if(formDisabled){
                                        setOpenClearRateToEditModal(true)
                                    }
                                }}
                                renderValue={value => {
                                    if(value){
                                        const stop = formik.values.stops?.stops?.find(s => s.stopNumber === value)
                                        if(window.innerWidth > 990){
                                            return (
                                                <div className="row">
                                                    <div className="col-12">Stop #{stop.stopNumber}</div>
                                                </div>
                                            )
                                        }else{
                                            return value
                                        }
                                    }else{
                                        if(window.innerWidth > 480){
                                            return 'Stop#'
                                        }else{
                                            return 'STP'
                                        }
                                    }
                                }}
                                inputProps={{
                                    IconComponent: KeyboardArrowDownIcon,
                                    MenuProps: menuProps,
                                    style: stylesMUIInput(fontSize),
                                }}
                                style={{
                                    color: freight.stopNumber ? '#5E6278' : '#A1A5B6',
                                }}
                                fontSize={fontSize}
                            >
                                {
                                    formik.values.stops?.stops.map((stop) => {
                                        return <MenuItem value={stop.stopNumber}>
                                            <div className="row">
                                                <div className="col-12" style={{fontWeight: 600}}>Stop #{stop.stopNumber}</div>
                                                <div className="col-12">{`${stop.city}, ${stop.state} ${stop.zipcode}`}</div>
                                            </div>
                                        </MenuItem>
                                    })
                                }
                            </SelectStyled>
                        </div>
                    : null
                }
                <div className="d-flex align-items-center" style={{flex: 1, minWidth: 'max-content'}}>
                    <div
                        onClick={() => {
                            if(!disabled){
                                if(!formDisabled){
                                    addNewFreight()
                                }else{
                                    setOpenClearRateToEditModal(true)
                                }
                            }
                        }}
                        style={{cursor: disabled ? 'default' : 'pointer'}}
                        className={`me-2 mb-2 mb-xl-0 mt-4 ${!hazEnabled ? 'ms-2' : ''}`}
                    >
                        <KTSVG path='/media/icons/bootstrap/plus-circle-fill.svg' className='svg-icon svg-icon-1 text-primary' style={{verticalAlign: 'bottom', marginRight: '10px', minHeight: '30px'}}/>
                    </div>
                    {
                        index > 0 &&
                        <div
                            onClick={() => {
                                if(!disabled){
                                    if(!formDisabled){
                                        setSelectedUn(selectedUn?.filter(s => s.index !== index))
                                        removeFreight(freight.id)
                                    }else{
                                        setOpenClearRateToEditModal(true)
                                    }
                                }
                            }}
                            style={{cursor: disabled ? 'default' : 'pointer'}}
                            className="me-2 mb-2 mb-xl-0 mt-4"
                        >
                        <KTSVG path='/media/icons/bootstrap/dash-circle-fill.svg' className='svg-icon svg-icon-1 text-danger' style={{verticalAlign: 'bottom', marginRight: '10px', minHeight: '30px'}}/>
                        </div>
                    }
                    <FreightSnapAction
                        index={index}
                        setDataFormik={setDataFormik}
                        BOLNumber={formik?.values?.BOLNumber}
                        currentFreightSnapId={freight?.freightsnapId}
                        currentQty={freight?.qty}
                        currentWeight={freight?.weightus}
                        currentL={freight?.Lus}
                        currentW={freight?.Wus}
                        currentH={freight?.Hus}
                        freightInfoUOM={freightInfoUOM}
                        hasRate={!!formikValues?.carrierInformation?.name}
                        disabled={disabled}
                    />
                </div>
            </div>
            </DivContainerStyled>
            <ShippingItemsModal
                open={openShippingItemsModal}
                setOpen={setOpenShippingItemsModal}
                setDataFormik={setDataFormik}
                index={index}
                onApply={clearFreightSnapRef}
            />
            <UNLookupModal
                open={openUNModal}
                setOpen={setOpenUNModal}
                setUNNumber={value => setDataFormik(`freightInfo[${index}].UN`, value)}
                setOpenHazContactModal={setOpenHazContactModal}
                selectedUn={selectedUn}
                setSelectedUn={setSelectedUn}
                searchUNTable={searchUNTable}
                setSearchUNTable={setSearchUNTable}
                index={index}
                emergencyContact={formik?.values?.emergencyContact}
            />
            <NMFCLookupModal
                open={openNMFCModal}
                setOpen={setOpenNMFCModal}
                setFormikValues={setDataFormik}
                searchFormik={formik.values.freightInfo[index].nmfcSearch}
                index={index}
                setOpenClearRateToEditModal={setOpenClearRateToEditModal}
                formikValues={formik.values}
                setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
            />
            <RequireClassITModal
                open={openRequireClassITModal}
                setOpen={setOpenRequireClassITModal}
            />
        </>
    )
})

export default FreightInformation